import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal } from '../../atoms/Modal/Modal';
import { Typography } from '../../typo/Typography';
import { Button } from '../../Button/Button';
import { useAllLocales } from '../../../hooks/locale/useAllLocales';
import { useUserField } from '../../userFields/useUserField';
import { useHasState } from '../hooks/useHasState';
import { useUser } from '../../../hooks/api/gql/user/queries/useUser';
import { useGetLocalizedKey } from '../helper/getTaxLocalizedKey';

interface IProfileTaxModal6Props {
    // getLocalizedKey: (key: string, countryOverwrite?: string) => string;
}

export const ProfileTaxModal6: React.FC<IProfileTaxModal6Props> = () => {
    const locales = useAllLocales();
    const { saveUserFields } = useUserField();
    const { hasState } = useHasState();
    const [show, setShow] = useState(false);

    const { getLocalizedKey, getLocalizedSuffix } = useGetLocalizedKey();

    const { data: userData } = useUser();

    const country = useMemo(() => {
        return userData?.fields.BL_Country_Origin ?? 'de-DE';
    }, [userData?.fields.BL_Country_Origin]);

    const LLSuffix: string | undefined = useMemo(() => {
        return getLocalizedSuffix(country);
    }, [country, getLocalizedSuffix]);

    const handleConfirm = useCallback(() => {
        saveUserFields([
            {
                name: 'Invoice_Tax_State',
                value: '7',
            },
        ]);
    }, [saveUserFields]);

    useEffect(() => {
        if (hasState([6])) {
            setShow(true);
        }
    }, [hasState]);

    return (
        <Modal show={show} afterClose={() => {}} closeable={false}>
            {locales && (
                <div className="flex flex-col gap-6 p-4">
                    <Typography variant="h1-green">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S6_H1_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>
                    <Typography variant="h3">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S6_H2_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>

                    <Typography variant="paragraph">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getLocalizedKey(
                                    'LL_PopUp_WaWi_ValdierungInfo_S6_C1_DE',
                                    LLSuffix
                                ),
                            }}
                        />
                    </Typography>

                    <div className="flex flex-col gap-4 mt-4 ">
                        <Button color="primary" onClick={handleConfirm}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: getLocalizedKey(
                                        'LL_PopUp_WaWi_ValdierungInfo_S6_B1_DE',
                                        LLSuffix
                                    ),
                                }}
                            />
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
};
